/**
 * The earliest moment the appointment form accepts: the start of today. A visit that already
 * started today must still be bookable (and then recorded), so earlier times today are valid;
 * days before today are not. The backend accepts any date.
 */
export function appointmentMinDate(now = new Date()): string {
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  return start.toISOString();
}
